import { render, staticRenderFns } from "./ChainCardShowPrice.vue?vue&type=template&id=362c257a&scoped=true&"
import script from "./ChainCardShowPrice.vue?vue&type=script&lang=ts&"
export * from "./ChainCardShowPrice.vue?vue&type=script&lang=ts&"
import style0 from "./ChainCardShowPrice.vue?vue&type=style&index=0&id=362c257a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362c257a",
  null
  
)

export default component.exports